import {
    isInViewport
} from '../../util/helper';

export default function () {
    window.onscroll = () => {
        const tableComponents = document.querySelectorAll('.table-responsive .table');

        if (tableComponents) {
            for (var i = 0, len = tableComponents.length; i < len; i++) {
                if (tableComponents[i].offsetWidth > tableComponents[i].parentNode.offsetWidth) {
                    tableComponents[i].parentNode.classList.add('table-scroll');
                    if (isInViewport(tableComponents[i].parentNode)) {
                        tableComponents[i].parentNode.classList.add('hide');
                    }
                }
            }
        }
    };
}
